/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/no-array-index-key */
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';
import { trimStringFields } from '@brands/Utils/trimStringFields';
import { UnifiedProfileSubmit } from '@brands/Utils/types';
import { validateAddress, ValidationModalInterface } from '@brands/Utils/validateAddress';
import { yupResolver } from '@hookform/resolvers/yup';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import cn from 'classnames';
import { Alert, AlertTitle, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { E164Number, parsePhoneNumber } from 'libphonenumber-js';
import moment from 'moment';
import React, { FC, KeyboardEventHandler, useEffect, useMemo, useState } from 'react';
import { useForm, UseFormGetValues, useWatch } from 'react-hook-form';
import { IoIosAddCircle } from 'react-icons/io';
import { TiDelete } from 'react-icons/ti';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';

import SuccessAlert from '../../../../../Components/Alert/SuccessAlert';
import Button from '../../../../../Components/Button/Button';
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import MultiSelectInputMUI from '@brands/Components/Inputs/MuiMultiSelectInput/MultiSelectInputMUI';
import PhoneInput from '@brands/Components/Inputs/MuiTelInput/MuiTelInput';
import ProfileImage from '../../../../../Components/ProfileImage/ProfileImage';
import { RegisterMediaPayload } from '../../../../../services/communication/registersConversationMedia';
import { confirmAvatarMedia } from '../../../../../services/identity/confirmAvatarMedia';
import { createBasicInformation } from '../../../../../services/identity/createBasicInformation';
import { createNewUser, fullNameFromFirstAndLast } from '../../../../../services/identity/createNewUser';
import { createProviderLicense } from '../../../../../services/identity/createProviderLicense';
import { createProviderProfile } from '../../../../../services/identity/createProviderProfile';
import { deleteAvatar } from '../../../../../services/identity/deleteAvatar';
import { listAllClientTags } from '../../../../../services/identity/listAllClientTags';
import { scopeClientTagOptionsToActor } from '../../../../../services/identity/clientTagActorScope';
import { listAllLanguages } from '../../../../../services/identity/listAllLanguages';
import { listInsuranceCarriers } from '../../../../../services/identity/listInsuranceCarriers';
import { registerAvatarMedia } from '../../../../../services/identity/registerAvatarMedia';
import { updateUserClientTag } from '../../../../../services/identity/updateUserClientTag';
import {
  getAllowedDivisionIds,
  getClientDivisionOptions,
} from '../../../../../services/identity/clientDivisionOptions';
import {
  getNetworkOptionsForRole,
  listNetworkOptions,
  NetworkOption,
} from '../../../../../services/identity/networkOptions';
import { updateUserNetwork } from '../../../../../services/identity/updateUserNetwork';
import {
  Address,
  BasicInfo,
  ClientTag,
  Language,
  ProviderProfile,
  UserProfile,
  UserRoleName,
} from '../../../../../services/identity/types/UserProfile';
import { checkAndSetDate } from '../../../../../Utils/checkAndSetDate';
import { multiSelectCommonCustomStylesLarge } from '../../../../../Utils/customStyles';
import { displayErrorDetails } from '../../../../../Utils/displayError';
import { genderIdentity, genderOptions, pronounsOptions } from '../../../../../Utils/selectButtonOptions';
import {
  licenseOptions,
  OptionInsurance,
  OptionLanguage,
  specialtyOptions,
  stateOptions,
} from '../../../../../Utils/selectOptions';
import { defaultFormValues } from '../../../../MyProfile/Provider/utils/defaultFromValues';
import { ProviderMyProfileSubmit } from '../../../../MyProfile/Provider/utils/types';
import AddressSection from '../../Components/AddressSection/AddressSection';
import styles from '../styles.module.scss';
import { validationSchema } from './validationSchema';

const components = {
  DropdownIndicator: null,
};

interface ProfileCardProps {
  onClose: () => void;
}

const AddProviderUserPage: FC<ProfileCardProps> = ({ onClose }) => {
  const { userInfo } = useAppSelector(selectAuth);
  const [myProfileForm, setMyProfileForm] = useState<ProviderMyProfileSubmit>(
    defaultFormValues as ProviderMyProfileSubmit,
  );
  const [insurancePlanName, setInsurancePlanName] = useState<OptionInsurance[]>([]);
  const [currentAvatarURL, setCurrentAvatarURL] = useState<string>('');
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [isProfileSaved] = useState(false);
  const [avatarPayload, setAvatarPayload] = useState<RegisterMediaPayload | null>(null);
  const [selection, setSelection] = React.useState<[number | null, number | null] | null>(null);
  const ref = React.useRef<HTMLInputElement>(null);
  const [languageOptions, setLanguageOptions] = useState<OptionLanguage[]>([]);
  const [clientTagOptions, setClientTagOptions] = useState<OptionLanguage[]>([]);
  const [allClientTags, setAllClientTags] = useState<ClientTag[]>([]);
  const [networkOptions, setNetworkOptions] = useState<NetworkOption[]>([]);
  const [avatarAction, setAvatarAction] = useState<string>('');
  const [image, setImage] = React.useState<string>();
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const [isSendingInvitation, setIsSendingInvitation] = useState(false);
  const [isEducationFocused, setIsEducationFocused] = useState(false);
  const [validationResponseId, setValidationResponseId] = useState('');
  const [showValidationAddressModal, setShowValidationAddressModal] = useState<ValidationModalInterface>({
    isOpen: false,
    title: '',
    whatYouEntered: '',
    recommended: false,
    recommendedAddress: '',
    onClose: undefined,
    onConfirmChange: undefined,
    onKeepCurrentAddress: undefined,
  });
  const closePage = (): void => {
    onClose();
  };
  const canEditNetwork = userInfo.role.name === UserRoleName.Admin || userInfo.role.name === UserRoleName.SuperAdmin;
  // Required for every role once the field is actually on the page (mirrors the
  // `clientTagOptions.length > 0` visibility check on the Client tag select below) --
  // requiredness used to be gated to CareAdvisor/Collector/OrganizationAdmin only.
  const clientTagsRequired = useMemo(() => clientTagOptions.length > 0, [clientTagOptions]);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    control,
  } = useForm<ProviderMyProfileSubmit>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema(clientTagsRequired)),
  });

  const getNewID = (id: number): number => {
    const newId = id + 1;
    if (myProfileForm.licences.find((licence) => licence.id === newId)) {
      return getNewID(newId);
    }
    return newId;
  };

  const addLicenseRow = (): void => {
    const newId = getNewID(
      myProfileForm.licences.length > 0 ? myProfileForm.licences[myProfileForm.licences.length - 1].id! : 0,
    );

    const newLicense = {
      id: newId,
      state: '',
      number: '',
      expiry_date: '',
      insurance_carriers: [],
    };

    setMyProfileForm((prev) => ({
      ...getValues(),
      licences: [...prev.licences, newLicense],
    }));
  };

  const handleRemoveRow = (id: number): void => {
    const updatedLicences = myProfileForm.licences.filter((licence) => licence.id !== id);
    setMyProfileForm(() => ({
      ...getValues(),
      licences: updatedLicences,
    }));
  };

  const handleRemoveInsurancePlanRow = (id: number, index: number): void => {
    const updatedLicences = myProfileForm.licences.map((licence) => {
      if (licence.id === id) {
        const updatedInsurancePlans = licence.insurance_carriers.filter((_, i) => i !== index);
        return {
          ...licence,
          insurance_carriers: updatedInsurancePlans,
        };
      }
      return licence;
    });
    setMyProfileForm(() => ({
      ...getValues(),
      licences: updatedLicences,
    }));
  };

  const triggerProfileAvatar = React.useCallback((avatarUrl: string) => {
    setValue('profile_img', avatarUrl, { shouldValidate: true });
    setMyProfileForm({
      ...getValues(),
      profile_img: avatarUrl,
    });
  }, []);

  const onCloseConfirmationModal = (): void => {
    setShowValidationAddressModal({
      isOpen: false,
      title: '',
      whatYouEntered: '',
      recommended: false,
      recommendedAddress: '',
      onClose: undefined,
      onConfirmChange: undefined,
      onKeepCurrentAddress: undefined,
    });
  };

  const fetchLanguageOptions = async (): Promise<void> => {
    try {
      const data = await listAllLanguages();
      const transformedData = data.map((language) => ({
        value: language.locale,
        label: language.name,
        id: language.id,
      }));
      setLanguageOptions(transformedData);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const fetchInsurancePlanOptions = async (): Promise<void> => {
    try {
      const data = await listInsuranceCarriers();
      const transformedData = data.map((insurancePlan) => ({
        id: insurancePlan.id,
        label: insurancePlan.name,
        value: insurancePlan.id,
      }));
      setInsurancePlanName(transformedData);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const fetchClientTagOptions = async (): Promise<void> => {
    try {
      const { nodes: tags } = await listAllClientTags();
      const withCode = (tags || []).filter((t: ClientTag) => Boolean(t.code));
      const mapped = withCode.map((t: ClientTag) => ({
        value: String(t.id),
        label: t.name,
        id: String(t.id),
      }));
      setClientTagOptions(scopeClientTagOptionsToActor(mapped, userInfo));
      setAllClientTags(withCode);
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  const watchedClientTagIds = useWatch({ control, name: 'client_tags' });
  const selectedClientTagIds = (watchedClientTagIds || []).map((id) => String(id));
  const divisionOptions = useMemo(
    () =>
      getClientDivisionOptions(allClientTags, selectedClientTagIds).map((option) => ({
        id: option.id,
        value: String(option.value),
        label: option.label,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allClientTags, JSON.stringify(selectedClientTagIds)],
  );

  const fetchNetworkOptions = async (): Promise<void> => {
    if (!canEditNetwork) return;
    try {
      const catalog = await listNetworkOptions(userInfo.role.name);
      setNetworkOptions(getNetworkOptionsForRole(catalog, UserRoleName.Provider));
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
  };

  useEffect(() => {
    fetchLanguageOptions();
    fetchInsurancePlanOptions();
    fetchClientTagOptions();
    fetchNetworkOptions();
  }, []);

  const setTextValue = (e: React.ChangeEvent<HTMLInputElement>, name: string): void => {
    const { value } = e.target;
    setValue(name as keyof ProviderMyProfileSubmit, value, { shouldValidate: true });
    setSelection([e.target.selectionStart, e.target.selectionEnd]);
  };

  React.useLayoutEffect(() => {
    if (selection && ref.current) {
      [ref.current.selectionStart, ref.current.selectionEnd] = selection;
    }
  }, [selection]);

  useEffect(() => {
    if (Object.keys(myProfileForm).length > 0) {
      Object.keys(myProfileForm).forEach((key: unknown) => {
        setValue(key as keyof ProviderMyProfileSubmit, myProfileForm[key as keyof ProviderMyProfileSubmit]);
      });
    }
  }, [myProfileForm, setValue]);

  const onInvalid = (errorsList: Record<string, { message?: string }>): void => {
    const error = Object.values(errorsList)[0];
    if (error?.message) {
      toast.error(error.message);
    }
  };

  const onCancelEditProfile = (): void => {
    onClose();
    setImage(currentAvatarURL);
  };

  const callSaveProfile = async (profileData: ProviderMyProfileSubmit): Promise<void> => {
    const typedProfile = profileData as ProviderMyProfileSubmit;
    setIsSavingProfile(true);
    let newUser: UserProfile | undefined;
    const fullNameForCreateUser = fullNameFromFirstAndLast(profileData.first_name, profileData.last_name);
    const client_ids = (typedProfile.client_tags || [])
      .map((id) => Number(id))
      .filter((n) => Number.isInteger(n) && n > 0);
    try {
      newUser = await createNewUser({
        email: profileData.email?.toLowerCase(),
        ...(typedProfile.phone_number && {
          phone_number: parsePhoneNumber(typedProfile.phone_number, 'US')?.format('E.164') as string,
        }),
        ...(profileData.address1 !== '' ||
        profileData.address2 !== '' ||
        profileData.city !== '' ||
        profileData.state !== '' ||
        profileData.zip_code !== ''
          ? {
              address: {
                ...(profileData.address1 !== '' && { address1: profileData.address1 }),
                ...(profileData.address2 !== '' && { address2: profileData.address2 }),
                ...(profileData.city !== '' && { city: profileData.city }),
                ...(profileData.state !== '' && { state: profileData.state }),
                ...(profileData.zip_code !== '' && { zip_code: profileData.zip_code }),
              } as Address,
            }
          : {}),
        type: UserRoleName.Provider,
        // Every user belongs to Dentistry One; the backend adds its default division/practice.
        organization_ids: ['dentistry-one'],
        ...(client_ids.length > 0 && { client_ids }),
        send_invitation: isSendingInvitation,
        ...(fullNameForCreateUser ? { full_name: fullNameForCreateUser } : {}),
        // No organization is picked anymore, so there is no organization domain to invite
        // from; use the site the admin is on.
        frontend_website: window.location.origin,
      });
    } catch (error: unknown) {
      newUser = undefined;
      displayErrorDetails(error);
      setIsSavingProfile(false);
    }
    if (newUser) {
      try {
        const client_division_ids = (
          (typedProfile as unknown as { client_divisions?: string[] }).client_divisions || []
        )
          .map((id) => Number(id))
          .filter((n) => Number.isInteger(n) && n > 0);
        if (client_division_ids.length > 0) {
          await updateUserClientTag(newUser.id, { client_ids, client_division_ids });
        }
        const selectedNetwork = (typedProfile as unknown as { network?: string | null }).network;
        if (canEditNetwork && selectedNetwork) {
          await updateUserNetwork(newUser.id, selectedNetwork, userInfo.role.name);
        }
        if (
          profileData.first_name !== '' ||
          typedProfile.middle_name !== '' ||
          typedProfile.last_name !== '' ||
          typedProfile.gender !== '' ||
          typedProfile.pronouns !== '' ||
          (Array.isArray(typedProfile.languages) &&
            typedProfile.languages.length > 0 &&
            (typedProfile.languages[0] as Language).name !== '')
        ) {
          const basicInfoPayload: Record<string, unknown> = {
            ...(typedProfile.first_name && { first_name: typedProfile.first_name }),
            ...(typedProfile.middle_name && {
              middle_name: typedProfile.middle_name,
            }),
            ...(typedProfile.last_name && { last_name: typedProfile.last_name }),
            ...(typedProfile.gender && {
              gender: typedProfile.gender,
            }),
            ...(typedProfile.pronouns && {
              pronouns: typedProfile.pronouns,
            }),
            ...(typedProfile.gender_identity && {
              gender_identity: typedProfile.gender_identity,
            }),
            ...(typedProfile.languages && {
              languages: typedProfile.language?.map((language) => language.id),
            }),
          };
          await createBasicInformation(basicInfoPayload as BasicInfo, newUser.id);
        }
        const updateProfileData: ProviderProfile = {
          ...(typedProfile.education && {
            education: typedProfile.education,
          }),
          specialty: (typedProfile.specialty || []).map((option) => option.value).filter(Boolean),
          ...(typedProfile.biography && {
            biography: typedProfile.biography,
          }),
          ...(typedProfile.additional_credentials && {
            additional_credentials: typedProfile.additional_credentials,
          }),
          availability: [...(newUser?.provider_profile?.availability || [])],
          ...(typedProfile.national_provider_id && {
            national_provider_id: typedProfile.national_provider_id,
          }),
          ...(typedProfile.credentials && {
            credentials: typedProfile.credentials,
          }),
        };
        if (
          profileData.first_name !== '' ||
          (profileData as ProviderMyProfileSubmit).middle_name !== '' ||
          profileData.last_name !== '' ||
          (profileData as ProviderMyProfileSubmit).gender !== '' ||
          (profileData as ProviderMyProfileSubmit).pronouns !== '' ||
          (profileData as ProviderMyProfileSubmit).national_provider_id !== '' ||
          (profileData as ProviderMyProfileSubmit).credentials !== '' ||
          (Array.isArray((profileData as ProviderMyProfileSubmit).languages) &&
            (profileData as ProviderMyProfileSubmit).languages.length > 0 &&
            ((profileData as ProviderMyProfileSubmit).languages[0] as Language).name !== '')
        ) {
          await createProviderProfile(updateProfileData, newUser.id);
        }
        if (
          newUser !== undefined &&
          myProfileForm.licences.length > 0 &&
          (profileData as ProviderMyProfileSubmit).licences.length > 0
        ) {
          await Promise.all(
            myProfileForm.licences.map((licence) =>
              createProviderLicense(
                {
                  state: licence.state,
                  number: licence.number,
                  expiry_date: moment(licence.expiry_date).format('YYYY-MM-DD'),
                  insurance_carriers: licence?.insurance_carriers.map((plan) => {
                    return {
                      ...plan,
                      insurance_carrier_id: Number(plan.insurance_carrier_id),
                      effective_date: moment(plan.effective_date).format('YYYY-MM-DD'),
                      recredential_date: moment(plan.recredential_date).format('YYYY-MM-DD'),
                    };
                  }),
                },
                newUser?.id ?? 0,
              ),
            ),
          );
        }
        if (avatarPayload && avatarFile && avatarAction === 'Upload') {
          const res = await registerAvatarMedia(avatarPayload);
          const mediaId = res.files[0].upload_id;
          await fetch(res.files[0].upload_url, {
            method: 'PUT',
            body: avatarFile,
            headers: { 'content-type': avatarFile.type },
          });
          await confirmAvatarMedia(mediaId, newUser.id);
          triggerProfileAvatar(res.files[0].upload_url);
        } else if (avatarAction === 'Remove') {
          await deleteAvatar(newUser.id);
          triggerProfileAvatar('');
        }
        toast.success('Provider user created.', { className: 'fs-unmask' });
        onClose();
      } catch (error: unknown) {
        displayErrorDetails(error);
        setIsSavingProfile(false);
      }
    }
  };

  const updateCurrentAddress = (standardizedAddress: any, postalAddress: any, addressComponents: any): void => {
    const streetNumber = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'street_number',
    );
    const address1 = addressComponents.find((addressComponent: any) => addressComponent.componentType === 'route');
    const state = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'administrative_area_level_1',
    );

    if (postalAddress) {
      setValue('city', postalAddress.locality);
      setValue('zip_code', postalAddress.postalCode);
    }

    if (streetNumber || address1) {
      setValue('address1', `${streetNumber?.componentName?.text || ''} ${address1?.componentName?.text || ''}`.trim());
    }

    if (state) {
      setValue('state', state.componentName?.text || '');
    } else if (standardizedAddress?.state) {
      setValue('state', standardizedAddress.state);
    }
  };

  const onSubmitProfile = async (profileData: ProviderMyProfileSubmit): Promise<void> => {
    profileData = trimStringFields(profileData);
    if (
      profileData.address1 !== '' ||
      profileData.address2 !== '' ||
      profileData.city !== '' ||
      profileData.state !== '' ||
      profileData.zip_code !== ''
    ) {
      await validateAddress(
        profileData,
        getValues as UseFormGetValues<UnifiedProfileSubmit>,
        validationResponseId,
        callSaveProfile,
        setValidationResponseId,
        setShowValidationAddressModal,
        onCloseConfirmationModal,
        updateCurrentAddress,
      );
    } else callSaveProfile(profileData);
  };

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
        setValue('education', [...getValues('education'), inputValue], { shouldValidate: true });
        setInputValue('');
        event.preventDefault();
        return;
      case 'Tab':
        setValue('education', [...getValues('education'), inputValue], { shouldValidate: true });
        setInputValue('');
        event.preventDefault();
    }
  };
  const formContent = (
    <>
      <div className={cn(styles.profileContainer, styles.newDesignProfileContainer, styles.providerPixelPerfect)}>
        <div className={styles.contentContainer}>
          <div className={styles.contentContainerInner}>
            <div className={styles.editProfileContainer}>
              <div className={styles.backButtonContainer}>
                <button type="button" className={styles.backButton} onClick={onClose}>
                  <ChevronLeftIcon className={styles.backButtonIcon} aria-hidden />
                  Back
                </button>
              </div>
              <Alert severity="info" className={styles.createUserNotice}>
                <AlertTitle>Creating provider profile</AlertTitle>
              </Alert>
              <div className={styles.providerInviteSection}>
                <div className={styles.providerInviteTitle}>Send Invitation to user?</div>
                <ToggleButtonGroup
                  exclusive
                  size="small"
                  value={isSendingInvitation ? 'yes' : 'no'}
                  onChange={(_, value) => {
                    if (value !== null) {
                      setIsSendingInvitation(value === 'yes');
                    }
                  }}
                  className={styles.providerInviteToggle}
                >
                  <ToggleButton value="yes">Yes</ToggleButton>
                  <ToggleButton value="no">No</ToggleButton>
                </ToggleButtonGroup>
              </div>
              <div className={styles.separator} />
              <div className={styles.titleContainer}>
                <span className={styles.title}>Basic information</span>
              </div>
              <div className={styles.editContainer}>
                <form className={styles.formContainer} onSubmit={handleSubmit(onSubmitProfile, onInvalid)}>
                  <div className={styles.headerActionDiv}>
                    <ProfileImage
                      reviewProfile
                      setCurrentAvatarURL={setCurrentAvatarURL}
                      setAvatarFile={setAvatarFile}
                      setAvatarPayload={setAvatarPayload}
                      setAvatarAction={setAvatarAction}
                      triggerProfileAvatar={triggerProfileAvatar}
                      setImage={setImage}
                      image={image}
                      errors={errors}
                      size="80px"
                      isNewDependent
                    />
                  </div>
                  <div className={styles.row}>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <TextField
                        {...register('first_name')}
                        label="First Name"
                        required
                        errors={errors}
                        name="first_name"
                        value={getValues('first_name')}
                        onChange={(e) => setTextValue(e, 'first_name')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <TextField
                        {...register('middle_name')}
                        label="Middle Name"
                        errors={errors}
                        name="middle_name"
                        value={getValues('middle_name')}
                        onChange={(e) => setTextValue(e, 'middle_name')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <TextField
                        {...register('last_name')}
                        label="Last Name"
                        required
                        errors={errors}
                        name="last_name"
                        value={getValues('last_name')}
                        onChange={(e) => setTextValue(e, 'last_name')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <MUISelectInput
                        {...register('gender')}
                        name="gender"
                        label="Gender assigned at birth"
                        required
                        options={genderOptions}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={getValues('gender') || ''}
                        onChange={(value: string) => {
                          setValue('gender', value, { shouldValidate: true });
                        }}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <MUISelectInput
                        {...register('gender_identity')}
                        name="gender_identity"
                        label="Gender identity"
                        options={genderIdentity}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={getValues('gender_identity') || ''}
                        onChange={(value: string) => {
                          if (value) {
                            setValue('gender_identity', value, { shouldValidate: true });
                          }
                        }}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.details)}>
                      <MUISelectInput
                        {...register('pronouns')}
                        name="pronouns"
                        label="Pronouns"
                        options={pronounsOptions}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={getValues('pronouns') || ''}
                        onChange={(value: string) => {
                          if (value) {
                            setValue('pronouns', value, { shouldValidate: true });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={cn(styles.rowItem, styles.rowItemHalf)}>
                      <MultiSelectInputMUI
                        {...register('language')}
                        name="language"
                        label="Languages"
                        withId
                        options={languageOptions}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={(getValues('language') || []).map((language) => String(language.id))}
                        onChange={(ids: string[]) => {
                          const selected = languageOptions.filter((option) => ids.includes(String(option.id)));
                          setValue('language', selected, {
                            shouldValidate: true,
                          });
                        }}
                      />
                    </div>
                    <div className={cn(styles.rowItem, styles.rowItemHalf)}>
                      <div className={styles.inputWrapper}>
                        <PhoneInput
                          {...register('phone_number')}
                          label="Phone Number"
                          value={getValues('phone_number') as E164Number}
                          id="phone_number"
                          onChange={(val) => {
                            setValue('phone_number', val as string, {
                              shouldValidate: true,
                            });
                          }}
                          inputClass={styles.input}
                          errors={errors}
                          wrapperClassName={styles.inputWrapper}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.rowItem}>
                      <TextField
                        {...register('email')}
                        label="Email Address"
                        required
                        errors={errors}
                        name="email"
                        value={getValues('email')}
                        onChange={(e) => setTextValue(e, 'email')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                  </div>
                  <AddressSection
                    register={register}
                    errors={errors}
                    getValues={getValues}
                    setTextValue={setTextValue}
                    setValue={setValue}
                    showValidationAddressModal={showValidationAddressModal}
                    required={false}
                  />
                  <div className={styles.row}>
                    <div className={styles.rowItem}>
                      <div className={cn(styles.inputWrapper, styles.providerEducationField)}>
                        <div
                          className={cn(
                            styles.providerFloatingLabel,
                            (isEducationFocused || Boolean(inputValue) || (getValues('education') || []).length > 0) &&
                              styles.providerFloatingLabelActive,
                          )}
                        >
                          Education / Universities
                        </div>
                        <CreatableSelect
                          {...register('education')}
                          components={components}
                          inputValue={inputValue} // Update inputValue prop
                          isMulti
                          classNamePrefix="providerEducationSelect"
                          className={errors.education ? 'is-invalid' : 'is-valid'}
                          placeholder=""
                          menuIsOpen={false}
                          onKeyDown={handleKeyDown}
                          onFocus={() => setIsEducationFocused(true)}
                          value={getValues('education')?.map((item) => ({ label: item, value: item }))}
                          styles={multiSelectCommonCustomStylesLarge}
                          onInputChange={(newValue) => setInputValue(newValue)} // Update onInputChange prop
                          onChange={(value) => {
                            if (value) {
                              setValue(
                                'education',
                                value.map((v) => v.value),
                                { shouldValidate: true },
                              );
                            }
                          }}
                          onBlur={() => {
                            setIsEducationFocused(false);
                            if (inputValue) {
                              // Use educationInputValue instead of inputValue
                              setValue('education', [...getValues('education'), inputValue], {
                                shouldValidate: true,
                              }); // Use educationInputValue instead of inputValue
                            }
                          }}
                        />
                        <div
                          className={`${styles.invalidFeedback} invalid-feedback`}
                          style={{ display: errors.education?.message ? 'block' : 'none' }}
                        >
                          {errors.education?.message}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.rowItem}>
                      <MultiSelectInputMUI
                        {...register('specialty')}
                        name="specialty"
                        label="Specialties (select up to 6)"
                        styledTag
                        withId
                        options={(specialtyOptions as { value: string; label: string }[]).map((option) => ({
                          ...option,
                          id: String(option.value),
                        }))}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={(getValues('specialty') || []).map((specialty) =>
                          String(specialty.id || specialty.value),
                        )}
                        onChange={(ids: string[]) => {
                          if (ids.length > 6) return;
                          const selected = (specialtyOptions as { value: string; label: string }[])
                            .filter((option) => ids.includes(String(option.value)))
                            .map((option) => ({ ...option, id: String(option.value) }));
                          setValue('specialty', selected, {
                            shouldValidate: true,
                          });
                        }}
                      />
                    </div>
                    <div className={styles.rowItem}>
                      <TextField
                        {...register('additional_credentials')}
                        label="Additional Credentials"
                        errors={errors}
                        name="additional_credentials"
                        value={getValues('additional_credentials')}
                        onChange={(e) => setTextValue(e, 'additional_credentials')}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div className={styles.rowItem}>
                      <TextField
                        {...register('biography')}
                        name="biography"
                        label="Biography"
                        multiline
                        minRows={6}
                        errors={errors}
                        value={getValues('biography')}
                        onChange={(e) => {
                          setValue('biography', e.target.value, { shouldValidate: true });
                          setSelection([e.target.selectionStart, e.target.selectionEnd]);
                        }}
                        wrapperClassName={styles.inputWrapper}
                        inputClass={styles.input}
                      />
                    </div>
                  </div>
                  <div className={styles.separator} />
                  <div className={styles.providerAdminSectionHeader}>
                    <h3>Admin-Managed Information</h3>
                    <p>
                      The information in this section is managed by our admin team. While you can view it, edits cannot
                      be made directly here. If any details need to be updated, please email us at{' '}
                      <a href="mailto:providers@dentistry.one" className={styles.providerEmailLink}>
                        providers@dentistry.one
                      </a>
                      .
                    </p>
                  </div>
                  <div className={styles.providerSubsection}>
                    <div className={styles.providerSubsectionTitle}>
                      Licensure
                      <button
                        type="button"
                        onClick={addLicenseRow}
                        style={{ color: '#3498db', marginRight: '15px', textAlign: 'center' }}
                      >
                        <IoIosAddCircle /> Add License
                      </button>
                    </div>
                    <div className={`${styles.row} ${styles.licencesRow}`}>
                      {errors.licences && <div className={`${styles.invalidFeedback}`}>{errors.licences.message}</div>}
                      {myProfileForm.licences
                        .sort((a, b) => Number(a.id?.valueOf() ?? Infinity) - Number(b.id?.valueOf() ?? Infinity))
                        .map((licence, index) => (
                          <div className={styles.rowItems}>
                            <div className={cn(styles.rowItem, styles.details)}>
                              <MUISelectInput
                                {...register(`licences.${licence.id!}.state`)}
                                name="statesOfLicense"
                                label="State of License"
                                required
                                options={stateOptions}
                                wrapperClassName={styles.inputWrapper}
                                errors={errors}
                                value={licence.state || ''}
                                onChange={(value: string) => {
                                  if (value) {
                                    setMyProfileForm((prev) => ({
                                      ...getValues(),
                                      licences: [
                                        ...prev.licences.map((l) => {
                                          if (l.id === licence.id) {
                                            return {
                                              ...l,
                                              state: value,
                                            };
                                          }
                                          return l;
                                        }),
                                      ],
                                    }));
                                  }
                                }}
                              />
                            </div>
                            <div className={cn(styles.rowItem, styles.details)}>
                              <TextField
                                {...register(`licences.${licence.id!}.number`)}
                                label="License #"
                                required
                                errors={errors}
                                name="license_number"
                                value={licence.number}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  setMyProfileForm((prev) => ({
                                    ...getValues(),
                                    licences: [
                                      ...prev.licences.map((l) => {
                                        if (l.id === licence.id) {
                                          return {
                                            ...l,
                                            number: value,
                                          };
                                        }
                                        return l;
                                      }),
                                    ],
                                  }));
                                }}
                                wrapperClassName={styles.inputWrapper}
                                inputClass={styles.input}
                              />
                            </div>
                            <div className={cn(styles.rowItem, styles.details, styles.dobContainer)}>
                              <TextField
                                {...register(`licences.${licence.id!}.expiry_date`)}
                                label="Expiry Date"
                                required
                                errors={errors}
                                name="expiry_date"
                                onChange={(e) => {
                                  setMyProfileForm((prev) => ({
                                    ...getValues(),
                                    licences: [
                                      ...prev.licences.map((l) => {
                                        if (l.id === licence.id) {
                                          return {
                                            ...l,
                                            expiry_date: checkAndSetDate(e),
                                          };
                                        }
                                        return l;
                                      }),
                                    ],
                                  }));
                                }}
                                value={licence.expiry_date}
                                maxLength={10}
                                wrapperClassName={styles.inputWrapper}
                                inputClass={styles.input}
                              />
                            </div>
                            {myProfileForm.licences.length > 1 && (
                              <button
                                className={styles.removeBtm}
                                type="button"
                                onClick={() => handleRemoveRow(licence.id!)}
                                aria-label="Remove license"
                              >
                                <TiDelete />
                              </button>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className={styles.providerSubsection}>
                    {myProfileForm.licences.filter((licence) => licence.state).length === 0 && (
                      <div className={styles.providerSubsectionTitle}>Enrollments</div>
                    )}
                    <div className={`${styles.row} ${styles.licencesRow}`}>
                      <div className={styles.rowItemsContainer}>
                        {myProfileForm.licences.filter((licence) => licence.state).length > 0 ? (
                          myProfileForm.licences
                            .sort((a, b) => Number(a.id?.valueOf() ?? Infinity) - Number(b.id?.valueOf() ?? Infinity))
                            .map((licence) => (
                              <>
                                <div className={styles.licencesRowHeader}>
                                  {`Enrollments (${
                                    stateOptions.find((option) => option.value === licence.state)?.label.split(' - ')[1]
                                  })`}
                                  <button
                                    type="button"
                                    style={{
                                      color: '#3498db',
                                      marginRight: '15px',
                                      textAlign: 'center',
                                    }}
                                    onClick={() => {
                                      const newInsurancePlan = {
                                        effective_date: '',
                                        recredential_date: '',
                                      };
                                      setMyProfileForm((prev) => ({
                                        ...getValues(),
                                        licences: [
                                          ...prev.licences.map((l) => {
                                            if (l.id === licence.id) {
                                              return {
                                                ...l,
                                                insurance_carriers: [...l.insurance_carriers, newInsurancePlan],
                                              };
                                            }
                                            return l;
                                          }),
                                        ],
                                      }));
                                    }}
                                  >
                                    <IoIosAddCircle /> Add Insurance
                                  </button>
                                </div>
                                {licence.insurance_carriers?.map((insurancePlan, insurancePlanIndex) => (
                                  <div className={styles.providerEnrollmentPlan}>
                                    <div className={cn(styles.rowItems, styles.providerEnrollmentCarrierRow)}>
                                      <div className={cn(styles.rowItem, styles.details, styles.big)}>
                                        <MUISelectInput
                                          {...register(
                                            `licences.${licence.id!}.insurance_carriers.${insurancePlanIndex}.insurance_carrier_id`,
                                          )}
                                          name={`licences.${licence.id!}.insurance_carriers.${insurancePlanIndex}.insurance_carrier_id`}
                                          label="Insurance Carrier"
                                          required
                                          options={insurancePlanName}
                                          wrapperClassName={styles.inputWrapper}
                                          errors={errors}
                                          value={String(insurancePlan.insurance_carrier_id || '')}
                                          onChange={(value: string) => {
                                            if (value) {
                                              setMyProfileForm((prev) => ({
                                                ...getValues(),
                                                licences: [
                                                  ...prev.licences.map((l) => {
                                                    if (l.id === licence.id) {
                                                      return {
                                                        ...l,
                                                        insurance_carriers: [
                                                          ...l.insurance_carriers.map((plan, planIndex) => {
                                                            if (planIndex === insurancePlanIndex) {
                                                              return {
                                                                ...plan,
                                                                insurance_carrier_id: Number(value),
                                                              };
                                                            }
                                                            return plan;
                                                          }),
                                                        ],
                                                      };
                                                    }
                                                    return l;
                                                  }),
                                                ],
                                              }));
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className={cn(styles.rowItems, styles.providerEnrollmentDatesRow)}>
                                      <div className={cn(styles.rowItem, styles.details, styles.rowItemHalf)}>
                                        <TextField
                                          {...register(
                                            `licences.${licence.id!}.insurance_carriers.${insurancePlanIndex}.recredential_date`,
                                          )}
                                          label="Re-credentialing Date"
                                          required
                                          errors={errors}
                                          name="recredentialDateOfLicence"
                                          onChange={(e) => {
                                            setMyProfileForm((prev) => ({
                                              ...getValues(),
                                              licences: [
                                                ...prev.licences.map((l) => {
                                                  if (l.id === licence.id) {
                                                    return {
                                                      ...l,
                                                      insurance_carriers: [
                                                        ...l.insurance_carriers.map((plan, planIndex) => {
                                                          if (planIndex === insurancePlanIndex) {
                                                            return {
                                                              ...plan,
                                                              recredential_date: checkAndSetDate(e),
                                                            };
                                                          }
                                                          return plan;
                                                        }),
                                                      ],
                                                    };
                                                  }
                                                  return l;
                                                }),
                                              ],
                                            }));
                                          }}
                                          value={insurancePlan.recredential_date}
                                          maxLength={10}
                                          wrapperClassName={styles.inputWrapper}
                                          inputClass={styles.input}
                                        />
                                      </div>
                                      <div
                                        className={cn(
                                          styles.rowItem,
                                          styles.details,
                                          styles.rowItemHalf,
                                          styles.dobContainer,
                                        )}
                                      >
                                        <TextField
                                          {...register(
                                            `licences.${licence.id!}.insurance_carriers.${insurancePlanIndex}.effective_date`,
                                          )}
                                          label="Effective Date"
                                          required
                                          errors={errors}
                                          name="effectiveDateOfLicence"
                                          onChange={(e) => {
                                            setMyProfileForm((prev) => ({
                                              ...getValues(),
                                              licences: [
                                                ...prev.licences.map((l) => {
                                                  if (l.id === licence.id) {
                                                    return {
                                                      ...l,
                                                      insurance_carriers: [
                                                        ...l.insurance_carriers.map((plan, planIndex) => {
                                                          if (planIndex === insurancePlanIndex) {
                                                            return {
                                                              ...plan,
                                                              effective_date: checkAndSetDate(e),
                                                            };
                                                          }
                                                          return plan;
                                                        }),
                                                      ],
                                                    };
                                                  }
                                                  return l;
                                                }),
                                              ],
                                            }));
                                          }}
                                          value={insurancePlan.effective_date}
                                          maxLength={10}
                                          wrapperClassName={styles.inputWrapper}
                                          inputClass={styles.input}
                                        />
                                      </div>
                                      <button
                                        className={styles.removeBtm}
                                        type="button"
                                        onClick={() => handleRemoveInsurancePlanRow(licence.id!, insurancePlanIndex)}
                                        aria-label="Remove insurance plan"
                                      >
                                        <TiDelete />
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ))
                        ) : (
                          <div className={styles.rowItems}>-</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={styles.providerSubsection}>
                    <div className={styles.providerSubsectionTitle}>NPI AND CREDENTIALS</div>
                    <div className={cn(styles.row, styles.licenceHeader, styles.providerNpiCredentialsRow)}>
                      <div className={styles.licenceInfo}>
                        <div className={cn(styles.rowItem, styles.details)}>
                          <TextField
                            {...register('national_provider_id')}
                            label="Provider NPI #"
                            required
                            errors={errors}
                            name="national_provider_id"
                            value={getValues('national_provider_id')}
                            onChange={(e) => setTextValue(e, 'national_provider_id')}
                            wrapperClassName={styles.inputWrapper}
                            inputClass={styles.input}
                          />
                        </div>
                        <div className={cn(styles.rowItem, styles.details)}>
                          <MUISelectInput
                            {...register('credentials')}
                            name="credentials"
                            label="Credentials (DDS/DMD/RDH)"
                            required
                            options={licenseOptions}
                            wrapperClassName={styles.inputWrapper}
                            errors={errors}
                            value={getValues('credentials') || ''}
                            onChange={(value: string) => {
                              if (value) {
                                setValue('credentials', value, {
                                  shouldValidate: true,
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.separator} />
                  <div className={cn(styles.row, styles.providerOrganizationRow)}>
                    <div className={cn(styles.rowItem, styles.details, styles.big)}>
                      <MultiSelectInputMUI
                        {...register('client_tags')}
                        name="client_tags"
                        label="Client tag(s)"
                        withId
                        required={clientTagsRequired}
                        options={clientTagOptions}
                        wrapperClassName={styles.inputWrapper}
                        errors={errors}
                        value={clientTagOptions.length > 0 ? selectedClientTagIds : []}
                        onChange={(ids: string[]) => {
                          setValue('client_tags', ids, { shouldValidate: true });
                          const allowedDivisionIds = getAllowedDivisionIds(allClientTags, ids);
                          setValue(
                            'client_divisions' as any,
                            ((getValues('client_divisions' as any) || []) as string[]).filter((id) =>
                              allowedDivisionIds.has(String(id)),
                            ),
                            { shouldValidate: true },
                          );
                        }}
                      />
                    </div>
                  </div>
                  {selectedClientTagIds.length > 0 && divisionOptions.length > 0 && (
                    <div className={cn(styles.row, styles.providerOrganizationRow)}>
                      <div className={cn(styles.rowItem, styles.details, styles.big)}>
                        <MultiSelectInputMUI
                          name="client_divisions"
                          label="Division(s)"
                          withId
                          options={divisionOptions}
                          wrapperClassName={styles.inputWrapper}
                          errors={errors}
                          value={(getValues('client_divisions' as any) || []) as string[]}
                          onChange={(ids: string[]) => {
                            setValue('client_divisions' as any, ids, { shouldValidate: true });
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {canEditNetwork && (
                    <div className={cn(styles.row, styles.providerOrganizationRow)}>
                      <div className={cn(styles.rowItem, styles.details, styles.big)}>
                        <MUISelectInput
                          name="network"
                          label="Network"
                          options={networkOptions.map((option) => ({
                            id: option.code,
                            value: option.code,
                            label: option.label,
                          }))}
                          wrapperClassName={styles.inputWrapper}
                          errors={errors}
                          value={getValues('network' as any) || ''}
                          onChange={(value: string) => {
                            setValue('network' as any, value || null, { shouldValidate: true });
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {isProfileSaved && <SuccessAlert />}
                  <div className={styles.providerActionBtnContainer}>
                    <Button type="submit" className={styles.providerSubmit} disabled={isSavingProfile}>
                      Save changes
                    </Button>
                    <Button type="button" className={styles.providerCancel} onClick={onCancelEditProfile}>
                      Cancel
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  /* Layout + scroll: parent AddUserPage already wraps with Container + #patientDashboardPosition. */
  return <>{formContent}</>;
};
export default AddProviderUserPage;
